<template>
  <v-progress-circular :value="100" :width="5" :indeterminate="false" color="primary" :class="getCucBorderClass">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          medium
          v-bind="attrs"
          :color="fileWasUploaded ? 'green' : 'red'"
          :style="getIconCheckUploadedFile == 'mdi-close' ? 'cursor: default !important' : ''"
          v-on="on"
          @click="$emit('CsvSentDeleted', groupFileName)"
        >
          {{ getIconCheckUploadedFile }}
        </v-icon>
      </template>
      {{ tooltipText }}
    </v-tooltip>
  </v-progress-circular>
</template>

<script>
  export default {
    props: {
      groupFileName: {
        type: String,
        required: true
      },
      switchValue: {
        type: Boolean,
        required: true
      },
      fileWasUploaded: {
        type: Boolean,
        required: true
      }
    },

    emits: ['CsvSentDeleted'],

    computed: {
      getIconCheckUploadedFile() {
        if (this.switchValue) {
          return this.fileWasUploaded ? 'mdi-check' : '';
        } else {
          return this.fileWasUploaded ? 'mdi-check' : 'mdi-close';
        }
      },

      indeterminateValue() {
        return this.getIconCheckUploadedFile == '' && this.switchValue ? true : false;
      },

      tooltipText() {
        let textBase = 'Clique aqui para remover o arquivo referente';
        let textForChecked = '';
        let textForNotChecked = '';

        if (this.groupFileName == 'material') {
          textForChecked = `${textBase} ao material`;
          textForNotChecked = `Nenhum arquivo referente ao material foi enviado`;
        } else {
          textForChecked = `${textBase} a tucagem`;
          textForNotChecked = `Nenhum arquivo referente a tucagem foi enviado`;
        }

        return this.getIconCheckUploadedFile == 'mdi-check' ? textForChecked : textForNotChecked;
      },

      getCucBorderClass() {
        let customClass = this.getIconCheckUploadedFile == 'mdi-check' ? 'border-cuc-green' : 'border-cuc-red';
        return !this.indeterminateValue ? customClass + ' border-cuc' : '';
      }
    }
  };
</script>

<style>
  .border-cuc svg {
    opacity: 0 !important;
  }
  .border-cuc .v-progress-circular__info {
    border-radius: 50% !important;
    padding: 5px;
  }

  .border-cuc-red .v-progress-circular__info {
    border: 1px solid red;
  }

  .border-cuc-green .v-progress-circular__info {
    border: 1px solid green;
  }
</style>